import React, { Component } from 'react';
import { Row, Col, Input, Form, FormGroup, Table, Label } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';

class CustomerMeetings extends Component {
    constructor(props) {
        super(props);
        this.selectorArr = this.props.selector != null && this.props.selector !== '' ? this.props.selector.split('/') : [];
        this.state = {
            data: [],
            sheetData: [],
            startDate: this.selectorArr.length > 0 && this.selectorArr[0] != null ? (this.selectorArr[0]) : String(new Date().toISOString()).substring(0, 10),
            endDate: this.selectorArr.length > 1 && this.selectorArr[1] != null ? (this.selectorArr[1]) : String(new Date().toISOString()).substring(0, 10),
            selectedClient: this.selectorArr.length > 2 && this.selectorArr[2] != null ? parseInt(this.selectorArr[2]) : 0,
            selectedEmployee: this.selectorArr.length > 3 && this.selectorArr[3] != null ? parseInt(this.selectorArr[3]) : 0,
            selectedTeam: this.selectorArr.length > 4 && this.selectorArr[4] != null ? parseInt(this.selectorArr[4]) : 0,
            selectedDepartment: this.selectorArr.length > 5 && this.selectorArr[5] != null ? parseInt(this.selectorArr[5]) : 0,
        };
        this.columns = ['Meeting Date', 'Client', 'CSSI Meeting Leader', 'CSSI Personnel', 'Customer Personnel', 'Meeting Notes', 'Next Steps', 'Department', 'Team', 'Primary Contact']
    }

    componentDidMount() {
        this.props.log('CustomerMeetings.js/componentDidMount');
        this.onSubmit();
    }

    onSubmit = () => {
        this.props.log('CustomerMeetings.js/onSubmit');
        fetch('/api/reports/CustomerMeetings', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            },
            body: JSON.stringify([
                { key: 'startDate', type: 'date', value: this.state.startDate },
                { key: 'endDate', type: 'date', value: this.state.endDate }
            ])
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    let data = results.data;
                    this.setState({
                        data: this.processData(data),
                    }, () => this.getCSVdata());
                } else {
                    this.props.addToast('Unable to download report.', 5, 'danger');
                }
            })
        // .catch(() => {
        //     this.props.addToast('An error has occurred.', 5, 'danger');
        // })
    }

    processData = (data) => {
        this.props.log('CustomerMeetings.js/processData (data)', data);
        data = data.map(item => {
            return {
                ...item,
                date: this.formatDate(item.date),
            }
        })
        return data;
    }

    formatDate = (d) => {
        if (parseInt(String(d).substring(0, 4)) <= 2000) return "";
        return parseInt(String(d).substring(5, 7)) + '/' + parseInt(String(d).substring(8, 10)) + '/' + parseInt(String(d).substring(0, 4));
    }

    getTime = (time) => {
        if (time == null || time === '') return '';
        var hours = parseInt(time.substring(0, 2)),
            minutes = parseInt(time.substring(3, 5)),
            ampm = 'am';
        if (hours === 12) {
            ampm = 'pm';
        } else if (hours === 0) {
            hours = 12;
        } else if (hours > 12) {
            hours -= 12;
            ampm = 'pm';
        }
        return hours + ':' + String(minutes).padStart(2, '0') + ' ' + ampm;
    }

    onChange = (e, submit) => {
        this.props.log('CustomerMeetings.js/onChange (name, value, e, submit)', e.target.name, e.target.value, e, submit);
        e.persist();
        this.setState({
            [e.target.name]: (e.target.value)
        }, () => {
            this.props.changeSelector({ target: { value: String((this.state.startDate) + '/' + (this.state.endDate) + '/' + (this.state.selectedClient) + '/' + (this.state.selectedEmployee) + '/' + (this.state.selectedTeam) + '/' + (this.state.selectedDepartment)).replace(/[/0]*$/, '') } })
            this.getCSVdata();
            if (submit) this.onSubmit();
        }
        );
    }

    getCSVdata = () => {
        this.props.log('CustomerMeetings.js/getCSVdata');
        let retArr = [[
            'Start Date: ',
            'End Date: ',
            'Client: ',
            'Employee: ',
            'Team: ',
            'Department: '
        ],
        [
            this.formatDate(this.state.startDate),
            this.formatDate(this.state.endDate),
            document.getElementById('selectedClient').options[document.getElementById('selectedClient').selectedIndex].text,
            document.getElementById('selectedEmployee').options[document.getElementById('selectedEmployee').selectedIndex].text,
            document.getElementById('selectedTeam').options[document.getElementById('selectedTeam').selectedIndex].text,
            document.getElementById('selectedDepartment').options[document.getElementById('selectedDepartment').selectedIndex].text
        ],
        [], this.columns];
        retArr = retArr.concat([...this.state.data]
            .filter(employee => parseInt(this.state.selectedClient) === 0 || parseInt(this.state.selectedClient) === parseInt(employee.clientId))
            .filter(employee => parseInt(this.state.selectedEmployee) === 0 || 
                (employee.employee != null && parseInt(this.state.selectedEmployee) === parseInt(employee.employee.employeeId)) ||
                (employee.meetingLeader != null && parseInt(this.state.selectedEmployee) === parseInt(employee.meetingLeader.employeeId)) ||
                (employee.cssiPersonnel != null && employee.cssiPersonnel.map(item => parseInt(item.employeeId)).findIndex(item => item === parseInt(this.state.selectedEmployee)) > -1)
            )
            .filter(employee => parseInt(this.state.selectedTeam) === 0 || (employee.employee != null && parseInt(this.state.selectedTeam) === parseInt(employee.employee.teamId)))
            .filter(employee => parseInt(this.state.selectedDepartment) === 0 || (employee.employee != null && employee.employee.departments != null && employee.employee.departments.length > 0 && employee.employee.departments.findIndex(department => department.id === parseInt(this.state.selectedDepartment))) > -1)
            .map(row => ([
                row.date,
                row.client,
                row.meetingLeader != null ? row.meetingLeader.lastName + ', ' + row.meetingLeader.firstName : '',
                row.cssiPersonnel.map((item,index) => item.lastName+', '+item.firstName).join('\n'),
                row.customerPersonnel,
                row.meetingNotes,
                row.nextSteps,
                row.employee.departments != null && row.employee.departments !== '' ? (row.employee.departments).map(item => item.departmentName).join(', ') : '',
                row.employee.team != null ? row.employee.team : '',
                row.employee != null ? row.employee.lastName + ', ' + row.employee.firstName : ''
            ]
            )))
        this.props.passData(retArr, "customer-meetings");
    }

    render() {
        this.props.info('CustomerMeetings.js/render');
        const filteredArray = [...this.state.data]
            .filter(employee => parseInt(this.state.selectedClient) === 0 || parseInt(this.state.selectedClient) === parseInt(employee.clientId))
            .filter(employee => parseInt(this.state.selectedEmployee) === 0 || 
                (employee.employee != null && parseInt(this.state.selectedEmployee) === parseInt(employee.employee.employeeId)) ||
                (employee.meetingLeader != null && parseInt(this.state.selectedEmployee) === parseInt(employee.meetingLeader.employeeId)) ||
                (employee.cssiPersonnel != null && employee.cssiPersonnel.map(item => parseInt(item.employeeId)).findIndex(item => item === parseInt(this.state.selectedEmployee)) > -1)
            )
            .filter(employee => parseInt(this.state.selectedTeam) === 0 || (employee.employee != null && parseInt(this.state.selectedTeam) === parseInt(employee.employee.teamId)))
            .filter(employee => parseInt(this.state.selectedDepartment) === 0 || (employee.employee != null && employee.employee.departments != null && employee.employee.departments.length > 0 && employee.employee.departments.findIndex(department => department.id === parseInt(this.state.selectedDepartment))) > -1);
        return (
            <>
                <Row className="mt-4">
                    <Col>
                        <Form inline>
                            <FormGroup className='mr-4 mb-2'>
                                <Label>Start Date
                                    <Input className="ml-2" type="date"
                                        name="startDate"
                                        onChange={(e) => this.onChange(e, true)}
                                        value={this.props.isFieldNull(this.state.startDate)}
                                    /></Label>
                            </FormGroup>
                            <FormGroup className='mr-4 mb-2'>
                                <Label>End Date
                                    <Input className='ml-2' type="date"
                                        name="endDate"
                                        onChange={(e) => this.onChange(e, true)}
                                        value={this.props.isFieldNull(this.state.endDate)}
                                    /></Label>
                            </FormGroup>
                            <FormGroup className='mr-2 mb-2'>
                                <Input type="select"
                                    name="selectedDepartment"
                                    id="selectedDepartment"
                                    onChange={(e) => this.onChange(e)}
                                    value={this.props.isFieldNull(this.state.selectedDepartment)}
                                >
                                    <option value="0">ALL DEPARTMENTS</option>
                                    {
                                        [...new Set(
                                            [...this.state.data]
                                                .filter(employee => employee.employee != null && employee.employee.departments != null && employee.employee.departments.length > 0 && employee.employee.departments.findIndex(department => department.id != null && department.id !== 0) > -1)
                                                .map(employee => employee.employee.departments).flat()
                                                .map(departments => { return JSON.stringify({ id: (departments.id != null ? departments.id : 0), departmentName: (departments.departmentName != null ? departments.departmentName : '') }) })
                                        )]
                                            .map(department => JSON.parse(department))
                                            .sort((a, b) => a.departmentName.localeCompare(b.departmentName))
                                            .map(department => (
                                                <option
                                                    key={"department_" + department.id}
                                                    value={this.props.isFieldNull(department.id)}
                                                >{department.departmentName}</option>
                                            ))
                                    }
                                </Input>
                            </FormGroup>
                            <FormGroup className='mr-2 mb-2'>
                                <Input type="select"
                                    name="selectedTeam"
                                    id="selectedTeam"
                                    onChange={(e) => this.onChange(e)}
                                    value={this.props.isFieldNull(this.state.selectedTeam)}
                                >
                                    <option value="0">ALL TEAMS</option>
                                    {
                                        [...new Set(
                                            [...this.state.data]
                                                .filter(row => row.employee != null && row.employee.teamId != null && row.employee.teamId !== 0)
                                                .map(row => { return JSON.stringify({ team: (row.employee.team != null ? row.employee.team : ''), teamId: (row.employee.teamId != null ? row.employee.teamId : 0) }) })
                                        )].map(team => JSON.parse(team))
                                            .sort((a, b) => a.team.localeCompare(b.team))
                                            .map(team => (
                                                <option
                                                    key={"team_" + team.teamId}
                                                    value={this.props.isFieldNull(team.teamId)}
                                                >{team.team}</option>
                                            ))
                                    }
                                </Input>
                            </FormGroup>
                            <FormGroup className='mr-2 mb-2'>
                                <Input type="select"
                                    name="selectedClient"
                                    id="selectedClient"
                                    onChange={(e) => this.onChange(e)}
                                    value={this.props.isFieldNull(this.state.selectedClient)}
                                >
                                    <option value={0}>ALL CLIENTS</option>
                                    {
                                        [...new Set([...this.state.data]
                                            .filter(row => row.clientId != null)
                                            .map(row => { return JSON.stringify({ client: row.client, clientId: row.clientId }) }))]
                                            .map(row => JSON.parse(row))
                                            .sort((a, b) => a.client.localeCompare(b.client))
                                            .map(client => (
                                                <option
                                                    key={"client_" + client.clientId}
                                                    value={this.props.isFieldNull(client.clientId)}
                                                >{client.client}</option>
                                            ))
                                    }
                                </Input>
                            </FormGroup>
                            <FormGroup className='mr-2 mb-2'>
                                <Input type="select"
                                    name="selectedEmployee"
                                    id="selectedEmployee"
                                    onChange={(e) => this.onChange(e)}
                                    value={this.props.isFieldNull(this.state.selectedEmployee)}
                                >
                                    <option value={0}>ALL EMPLOYEES</option>
                                    {
                                        [...new Set([...this.state.data]
                                            .filter(row => row.employee != null && row.employee.employeeId != null)
                                            .map(row => { return JSON.stringify({ name: row.employee.lastName + ', ' + row.employee.firstName, employeeId: row.employee.employeeId }) })
                                            .concat(
                                                [...this.state.data]
                                                    .filter(row => row.meetingLeader != null)
                                                    .map(row => { return JSON.stringify({ name: row.meetingLeader.lastName + ', ' + row.meetingLeader.firstName, employeeId: row.meetingLeader.employeeId }) })
                                            )
                                            .concat(
                                                [...this.state.data]
                                                    .filter(row => row.cssiPersonnel != null)
                                                    .map(row => {
                                                        return row.cssiPersonnel.map(personnel => {
                                                            return JSON.stringify({
                                                                name: personnel.lastName + ', ' + personnel.firstName,
                                                                employeeId: personnel.employeeId
                                                            })
                                                        }
                                                        )
                                                    }).flat()
                                            )
                                        )]
                                            .map(row => JSON.parse(row))
                                            .sort((a, b) => a.name.localeCompare(b.name))
                                            .map(employee => (
                                                <option
                                                    key={"employee_" + employee.employeeId}
                                                    value={this.props.isFieldNull(employee.employeeId)}
                                                >{employee.name}</option>
                                            ))
                                    }
                                </Input>
                            </FormGroup>
                        </Form>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col>
                        <h4>{filteredArray.length} Result{filteredArray.length === 1 ? '' : 's'}</h4>
                    </Col>
                </Row>
                <Table className='mt-3'>
                    <thead>
                        <tr>
                            {this.columns
                                .map(col => (
                                    <th key={col}>{col}</th>
                                ))}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredArray.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                <td>{row.date}</td>
                                <td>{row.client}</td>
                                <td>{row.meetingLeader != null ? row.meetingLeader.lastName + ', ' + row.meetingLeader.firstName : ''}</td>
                                <td>{row.cssiPersonnel.map((item,index) => <div key={index}>{item.lastName}, {item.firstName}</div>)}</td>
                                <td><div style={{ width: 250 }} className='text-wrap'>{row.customerPersonnel}</div></td>
                                <td><div style={{ width: 500 }} className='text-wrap'>{row.meetingNotes}</div></td>
                                <td><div style={{ width: 500 }} className='text-wrap'>{row.nextSteps}</div></td>
                                <td>{row.employee.departments != null && row.employee.departments !== '' ? (row.employee.departments).map(item => item.departmentName).join(', ') : ''}</td>
                                <td>{row.employee.team != null ? row.employee.team : ''}</td>
                                <td>{row.employee != null ? row.employee.lastName + ', ' + row.employee.firstName : ''}</td>
                            </tr>
                        ))
                        }
                    </tbody>
                </Table>
            </>
        );

    }
}

export default CustomerMeetings;
